export class MediaFileAssociationViewModel {
    public mediaFileAssociationId: string;
    public associationId: string;
    public entityName: string;
    public mediaUseCode: string;
    public mediaUseName: string;
    public mediaId: string;
}